import FullscreenLoader from "@/components/fullscreen-loader";
import { ScrollArea } from "@/components/ui/scroll-area";
import { SignUpForm } from "@/pages/sign-up/signup-form";
import { createFileRoute, Link, Navigate } from "@tanstack/react-router";
import { useSession } from "@wacht/tanstack-router";

export const Route = createFileRoute("/_auth/sign-up")({
  component: RouteComponent,
});

function RouteComponent() {
  const { loading } = useSession();

  if (loading) {
    return <FullscreenLoader />;
  }

  // NOTE: this redirecting to dashboard from step 2 without onboarding
  // if (isSignedIn) {
  //   return <Navigate to="/dashboard" />;
  // }

  return (
    <section className="bg-background p-2 ">
      <div className="relative grid grid-cols-1 lg:grid-cols-2 w-full">
        {/* Sign Up Link */}

        {/* Left Image Section */}
        <div className="relative flex-col bg-[#0a0a0a] text-white hidden lg:flex justify-between items-center rounded-2xl overflow-hidden h-[calc(100dvh-16px)]">
          <div className="absolute inset-0 w-full h-full p-10">
            <img
              src="/id_full_logo_white.png"
              alt="InboxDoctor"
              className="h-[50px] w-auto"
            />

            <div className="flex flex-col gap-2 relative top-[8%] lg:top-[10%] left-[8%] max-w-[500px]">
              <h1 className="text-3xl/[30px] xl:text-[40px]/[40px] font-bold ">
                Elevate Your Inboxing Game to New Heights
              </h1>
              <p className="text-lg text-gray-400">
                Boost email deliverability, warm-up automation, and domain
                monitoring to keep emails out of spam!
              </p>
            </div>
          </div>

          <img
            src="/auth-image.jpg"
            alt="InboxDoctor Interface"
            className="w-full h-full object-cover object-left-top"
          />
        </div>

        {/* Right Sign-in Section */}
        <div className="p-4 lg:p-8 h-[calc(100dvh-16px)] overflow-y-auto">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:max-w-[400px] h-full">
            <div className="lg:hidden flex justify-center items-center mb-2">
              <img
                src="/id_full_logo_black.png"
                alt="InboxDoctor"
                className="h-[50px] w-auto dark:hidden"
              />
              <img
                src="/id_full_logo_white.png"
                alt="InboxDoctor"
                className="h-[50px] w-auto hidden dark:block"
              />
            </div>

            {/* Auth Form */}
            <SignUpForm />

            {/* Terms of Service and Privacy Policy */}
            <p className="text-center lg:text-left text-sm text-muted-foreground">
              By clicking continue, you agree to our{" "}
              <a
                href="https://inboxdoctor.ai/legal/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                className="underline-offset-2 hover:underline font-medium text-primary"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://inboxdoctor.ai/legal/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="underline-offset-2 hover:underline font-medium text-primary"
              >
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
